import { useState } from "react";
import { X, Save } from "lucide-react";

const EMPTY = {
  category: "", subcategory: "", brand: "", product_name: "", variant: "", presentation: "",
  net_content_ml: "", pieces: "", unit: "pieza", package_type: "", barcode: "", image_url: "",
  variable_weight: false, returnable: false, aliases: "",
};

const FIELDS = [
  ["category", "Categoría *"], ["subcategory", "Subcategoría"], ["brand", "Marca"],
  ["product_name", "Nombre *"], ["variant", "Variante / sabor"], ["presentation", "Presentación"],
  ["net_content_ml", "Contenido (ml / g)"], ["pieces", "Piezas por paquete"], ["unit", "Unidad (pieza, kg, l)"],
  ["package_type", "Tipo de empaque"], ["barcode", "Código de barras (EAN)"], ["image_url", "URL de imagen"],
];

export const MasterProductModal = ({ initial, onClose, onSave, saving }) => {
  const [form, setForm] = useState(() => ({
    ...EMPTY,
    ...Object.fromEntries(Object.entries(initial || {}).filter(([, v]) => v !== null && v !== undefined)),
    aliases: (initial?.aliases || []).join(", "),
  }));
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const isEdit = Boolean(initial?.id);

  const submit = (e) => {
    e.preventDefault();
    const body = {
      ...form,
      net_content_ml: form.net_content_ml === "" ? null : Number(form.net_content_ml),
      pieces: form.pieces === "" ? null : parseInt(form.pieces, 10),
      aliases: form.aliases.split(",").map((s) => s.trim()).filter(Boolean),
    };
    ["subcategory", "brand", "variant", "presentation", "package_type", "barcode", "image_url"].forEach((k) => {
      if (!body[k]) body[k] = null;
    });
    delete body.id; delete body.created_at; delete body.updated_at; delete body.legacy_name;
    delete body.global_product_name; delete body.off_last_synced_at; delete body.country;
    delete body.regional_availability; delete body.seasonal; delete body.season_start; delete body.season_end;
    delete body.manufacturer; delete body.active;
    onSave(body);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" data-testid="mp-modal">
      <form onSubmit={submit} className="w-full max-w-2xl bg-[#0a0a0a] border border-white/10 rounded-3xl p-6 md:p-8 max-h-[92vh] overflow-y-auto">
        <div className="flex items-start justify-between mb-6">
          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] text-white/40 uppercase">/ Catálogo maestro</p>
            <h2 className="font-display text-2xl md:text-3xl tracking-tighter">{isEdit ? "Editar producto" : "Nuevo producto global"}</h2>
          </div>
          <button type="button" onClick={onClose} className="text-white/50 hover:text-white" data-testid="mp-modal-close"><X size={18} /></button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {FIELDS.map(([k, label]) => (
            <label key={k} className="block">
              <span className="font-mono text-[10px] uppercase tracking-widest text-white/40">{label}</span>
              <input
                value={form[k] ?? ""}
                onChange={(e) => set(k, e.target.value)}
                className="mt-1 w-full bg-black/60 border border-white/10 rounded-xl px-3 py-2 text-sm outline-none focus:border-[#ff5a00]/60"
                data-testid={`mp-field-${k}`}
              />
            </label>
          ))}
          <label className="block md:col-span-2">
            <span className="font-mono text-[10px] uppercase tracking-widest text-white/40">Alias (separados por coma)</span>
            <input value={form.aliases} onChange={(e) => set("aliases", e.target.value)} placeholder="coca, coquita, refresco de cola"
              className="mt-1 w-full bg-black/60 border border-white/10 rounded-xl px-3 py-2 text-sm outline-none focus:border-[#ff5a00]/60" data-testid="mp-field-aliases" />
          </label>
          <label className="flex items-center gap-2 text-sm text-white/70">
            <input type="checkbox" checked={!!form.variable_weight} onChange={(e) => set("variable_weight", e.target.checked)} data-testid="mp-field-variable_weight" /> Se vende a granel / por peso
          </label>
          <label className="flex items-center gap-2 text-sm text-white/70">
            <input type="checkbox" checked={!!form.returnable} onChange={(e) => set("returnable", e.target.checked)} data-testid="mp-field-returnable" /> Envase retornable
          </label>
        </div>
        <div className="mt-6 flex justify-end gap-2">
          <button type="button" onClick={onClose} className="px-4 py-2 rounded-full border border-white/10 text-xs font-mono uppercase tracking-widest text-white/60 hover:text-white">Cancelar</button>
          <button type="submit" disabled={saving} className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-[#ff5a00] text-black text-xs font-mono uppercase tracking-widest hover:bg-[#ff7a2a] disabled:opacity-50" data-testid="mp-modal-save">
            <Save size={14} /> {saving ? "Guardando…" : isEdit ? "Guardar cambios" : "Crear producto"}
          </button>
        </div>
      </form>
    </div>
  );
};
